import { render, staticRenderFns } from "./ApoiosDash.vue?vue&type=template&id=d241d204"
import script from "./ApoiosDash.vue?vue&type=script&lang=js"
export * from "./ApoiosDash.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports